import DolfinLogger from '.'

export class DolfinLoggerFactory {
  static create(): DolfinLogger {
    switch (process.env.LOGGER_TYPE) {
      case 'trigger':
        return require('./trigger').TriggerLogger
      default:
        return console
    }
  }
}

export default DolfinLoggerFactory
